/*
 * GORUCK Ruck Finder — loader (hand-written, not built).
 *
 * The app block renders the intro screen in Liquid, so nothing here runs
 * until a shopper shows intent. Hovering, focusing or touching the CTA starts
 * downloading the quiz bundle (ruck-finder-app.js); clicking it mounts the
 * quiz in place of the intro. Shoppers who never start the quiz never
 * download the bundle. Theme Check limits this file to 10 KB.
 */
(function () {
  var NS = 'GORUCKRuckFinder';
  var loading = null;

  function loadApp(src) {
    if (window[NS]) return Promise.resolve(window[NS]);
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function () {
        if (window[NS]) resolve(window[NS]);
        else reject(new Error('Ruck Finder failed to initialize'));
      };
      script.onerror = function () {
        loading = null; // allow a retry on the next click
        reject(new Error('Ruck Finder failed to load'));
      };
      document.head.appendChild(script);
    });
    return loading;
  }

  function init(block) {
    if (block.getAttribute('data-rf-ready')) return;
    block.setAttribute('data-rf-ready', 'true');

    var src = block.getAttribute('data-rf-src');
    var intro = block.querySelector('[data-rf-intro]');
    var app = block.querySelector('[data-rf-app]');
    var cta = block.querySelector('[data-rf-start]');
    var data = block.querySelector('[data-rf-data]');
    var error = block.querySelector('[data-rf-error]');
    if (!src || !intro || !app || !cta || !data) return;

    var unmount = null;
    var warm = function () {
      loadApp(src).catch(function () {});
    };
    cta.addEventListener('pointerenter', warm, { once: true });
    cta.addEventListener('focus', warm, { once: true });
    cta.addEventListener('touchstart', warm, { once: true, passive: true });

    function exit() {
      if (unmount) unmount();
      unmount = null;
      app.hidden = true;
      intro.hidden = false;
      cta.focus();
    }

    cta.addEventListener('click', function () {
      if (cta.getAttribute('aria-busy') === 'true') return;
      cta.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;
      loadApp(src)
        .then(function (api) {
          var payload = JSON.parse(data.textContent || '{}');
          intro.hidden = true;
          app.hidden = false;
          unmount = api.mount(app, payload, { onExit: exit });
        })
        .catch(function (err) {
          if (error) error.hidden = false;
          if (window.console) console.error('[ruck-finder]', err);
        })
        .then(function () {
          cta.removeAttribute('aria-busy');
        });
    });
  }

  function initAll(root) {
    var blocks = (root || document).querySelectorAll('[data-ruck-finder]');
    for (var i = 0; i < blocks.length; i++) init(blocks[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor re-renders sections in place; wire up the new markup.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
